import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { RumiService } from 'src/app/services/rumi.service';

@Component({
  selector: 'app-simulacio',
  templateUrl: './simulacio.component.html'
})
export class SimulacioComponent implements OnInit {

  constructor(
    private rumiService: RumiService
  ) { }

  ngOnInit(): void {    
  }

  public get simulacio(){
    return this.rumiService.simulacio;
  }

}
